
import Model from './Model'
import Combination from './Combination'

export default class OrderContentCombination extends Model {
  constructor (attributes = {}) {
    super(attributes.id)
    this.combination_id = attributes.combination_id // INT
    this.itemName = attributes.itemName ?? null // VARCHAR 255
    this.item_id = attributes.item_id // INT
    this.order_content_id = attributes.order_content_id // INT
    this.price = parseFloat(attributes.price) // DECIMAL 8,2

    this.combination = attributes.combination ? new Combination(attributes.combination) : null
  }

  toJSON () {
    delete this.item_id
    delete this.combination

    return this
  }
}
